// extracted by mini-css-extract-plugin
export default {"notAllowedPage":"NotAllowedPage_notAllowedPage__dKPht"};